export default "__VITE_ASSET__df51150f__"